import useElectronHook from "./useElectronHook";

const usePrint = () => {
  const { isElectron } = useElectronHook();

  return (data: any) => {
    if (isElectron) {
      window.api.send("print", data);
    } else {
      const myWindow = window.open("", "PRINT", "height=400,width=600");
      myWindow.document.write(data[0].html);
      myWindow.document.close(); // necessary for IE >= 10
      myWindow.focus(); // necessary for IE >= 10*/
      myWindow.print();
      setTimeout(() => {
        myWindow.close();
      }, 2000);
    }
  };
};

export default usePrint;
